<template>
<div>
  <el-button size="small" @click="onClickShowPopup">과점유 설정</el-button>
  <w-sliding-popup ref="slidingPopup" title="과점유 설정" width="400px" @close="onClosePopup">
    <div slot="content">
      <el-form class="mr-b25" label-position="top" :model="limitData">
        <el-form-item label="CPU 사용률 과점유 설정 (%)">
          <el-input-number v-model="limitData.processMaxCpuLimit" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="메모리 사용량 과점유 설정 (MB)">
          <el-input-number v-model="limitData.processMaxMemLimit" :min="0"></el-input-number>
        </el-form-item>
      </el-form>
      <hr class="mr-b20" />
      <el-row class="vertical-center-box title-bar" type="flex" justify="space-between">
        <span class="title-h4">그룹 저장</span>
        <el-switch v-model="showFlag"></el-switch>
      </el-row>
      <w-common-obj-list v-show="showFlag" ref="commonObjList" type="physical" selected-managetype-id="SMS" />
    </div>
    <el-row slot="footer" class="dialog-footer" type="flex" justify="center">
      <el-button size="large" type="solid" class="mr-r4" @click="saveStore">저장</el-button>
      <el-button size="large" @click="$refs.slidingPopup.close()">취소</el-button>
    </el-row>
  </w-sliding-popup>
</div>
</template>
<script>
import serverTableInfoAPI from '@/api/performance/server/info-table';
import WCommonObjList from '@/components/table/CommonObjList';
import MsgUtil from '@/utils/message';
import { forEach } from 'lodash';

export default {
  name: 'WOligopolyPopoverButton',
  components: {
    WCommonObjList,
  },
  data() {
    return {
      showFlag: false,
      limitData: {
        processMaxCpuLimit: 0,
        processMaxMemLimit: 0,
      },
    };
  },
  computed: {
    objId() {
      return this.$store.getters.selectedNode.obj.objId;
    },
  },
  methods: {
    onClickShowPopup() {
      this.$refs.slidingPopup.open();
      this.loadStore();
    },
    loadStore() {
      serverTableInfoAPI.getProcessOverloadSettings(this.objId).then((response) => {
        if (response.data.success === true) {
          this.limitData = response.data.data;
          this.$emit('formSubMit', this.limitData);
        }
      });
    },
    saveStore() {
      const params = [];
      if (this.showFlag) {
        const objIdArr = this.$refs.commonObjList.getSelectedObjList(true);
        forEach(objIdArr, (item) => params.push({
          processMaxCpuLimit: this.limitData.processMaxCpuLimit,
          processMaxMemLimit: this.limitData.processMaxMemLimit,
          objId: item,
        }));
        if (params.length < 1) {
          // 1. alert 경고 알리고 return;
          // 2. 경고 안하고 본인만 저장 - params.push - 본인
          params.push({
            processMaxCpuLimit: this.limitData.processMaxCpuLimit,
            processMaxMemLimit: this.limitData.processMaxMemLimit,
            objId: this.objId,
          });
        }
      }
      serverTableInfoAPI
        .updateProcessOverloadSettings(params)
        .then((response) => {
          if (response.data.success === true) {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.SAVE, '과점유 설정', true));
            this.$emit('update');
            this.$refs.slidingPopup.close();
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.SAVE, '과점유 설정', false));
        });
    },
    onClosePopup() {
      this.showFlag = false;
      this.$refs.commonObjList.initData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/server/components/button/OligopolyPopoverButton.vue